import CurrentUser from "./component";
import CurrentUserContainer from "./container";

export { CurrentUser, CurrentUserContainer };
export default CurrentUserContainer;



// WEBPACK FOOTER //
// ./client/modules/User/components/CurrentUser/index.ts